<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      v-if="trendShow"
      row-key="ProcessId"
      ref="list"
      unit="工序档案"
      :page="page"
      show-checkbox
      show-query
      :query-params="params"
      :get-data-func="api.list"
      @check-change="checkChange"
      :getColumn="tableColumns"
      :trendColumn="trendColumn"
      :getParams="tableParams"
      :trendParams="trendParams"
      urlHash="production/craftsmanship/archives"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
     
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div> 
</template>
<script> 
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/production/craftsmanship/archives/list.json";
import tableParam from "@/data/production/craftsmanship/archives/query.json";


export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      api: require('@/api/production/teProcess').default,

      
      commonApi: require("@/api/common/common").default,
      params: {
        ProcessNo: "",
        ProcessName: "",
        Stage: "",
      },
      ProductionPhaseOptions: [],
      ids: [],
      trendColumn: tableColumn.Data,
      tableColumns: tableColumn.Data,
      trendParams: tableParam.Data,
      tableParams: tableParam.Data,
      trendShow: true,
    };
  },
  created() {
    this.commonApi.getDictionaryList().then((res) => {
      this.ProductionPhaseOptions = res.Data.filter((v) => {
        return v.Code === "ProductStage";
      });
      let options = [];
      this.ProductionPhaseOptions.forEach(item => {
        let o = {
          key: item.DictionaryId,
          label: item.ItemText,
          value: item.ItemValue
        }
        options.push(o)
      })

      let length = this.tableParams.length;
      for(let i = 0; i < length; ++i){
        if(this.tableParams[i].title === '生产阶段'){
          this.tableParams[i].options = options;
        }
      }

    });
  },
  mounted(){
     
  },
  methods: {
    showParams() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.queryApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.tableParams.forEach((item) => {
            const DataItem = res.Data.filter((x) => x.ShowField == item.field);
            if (ShowField.indexOf(item.field) !== -1) {
              item.col.labelWidth = DataItem[0].TagsWidth;
              item.col.width = DataItem[0].ShowWidth;
            }
            // item.props.show = true
            item.props.show =
              ShowField.indexOf(item.field) !== -1 ? true : false;
          });
          return (this.tableParams = this.tableParams.filter(
            (x) => x.props.show == true
          ));
        }
      });
    },
    showTable() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.tableApi
        .list({ type: modeName })
        .then((res) => {
          if (res.Data === null || res.Data.length === 0) {
            return (this.trendShow = true);
          }
          if (res.Code == 0) {
            const ShowField = res.Data.map((x) => x.ShowField);
            this.tableColumns.forEach((item) => {
              const DataItem = res.Data.filter(
                (x) => x.ShowField == item.tableName
              );
              if (ShowField.indexOf(item.tableName) !== -1) {
                item.col.width = DataItem[0].ShowWidth;
                item.props.align = DataItem[0].Alignment;
                item.props.tooltip = DataItem[0].IsHidden;
              }
              // item.props.show = true
              item.props.show =
                ShowField.indexOf(item.tableName) !== -1 ? true : false;
            });
            this.trendShow = true;
            return (this.tableColumns = this.tableColumns.filter(
              (x) => x.props.show == true
            ));
          }
        })
        .then((res) => {
          this.getData();
        });
    },
    getFormData() {
      let modeName = location.hash.split("/").slice(1).join("");
      this.formApi.list({ type: modeName }).then((res) => {
        if (res.Data === null || res.Data.length === 0) return;
        if (res.Code == 0) {
          const ShowField = res.Data.map((x) => x.ShowField);
          this.fromData.map((item) => {
            item.show = ShowField.indexOf(item.field) !== -1 ? true : false;
          });
        }
      });
    },
    checkChange(ids) {
      this.ids = ids.map(v => {
        return v.ProcessId
      });
      
    },
    _del() {

      if(this.ids.length === 0){
        this.$message({type: 'warning', message: '请选择删除的数据'});
        return;
      }

      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        
        this.api.delete({ ids: this.ids }).then((res) => {
          if (res.Code === 0) {
            this.$message({ type: "success", message: res.Msg });
            this.reload();
          } else {
            this.$message({ type: "warning", message: res.Msg });
          }
        });
      });
    },
   
  },
};
</script>
